<template>
    <v-card>
        <v-form ref="refMain">
            <v-card-title :class="dColor">
                <span class="headline" style="color:white">Agregar</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xm="12" sm="4" class="pa-1">
                        <v-autocomplete v-model="dDcbItinerario.IdPeriodoInicio" label="* Periodo Inicio"
                            :items="dMatPeriodos"  item-value="IdPeriodoAdmision" item-text="Anio_Periodo"
                            :disabled="dIsUpdating" filled prepend-inner-icon="event_note" :rules="[v => !!v || 'El campo es requerido']">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" xm="12" sm="8" class="pa-1">
                        <v-autocomplete v-model="dDcbItinerario.IdServicio" label="* Carrera Profesional"
                            :items="ssPriServiciosIngreso"  item-value="IdServicio" item-text="Descripcion2"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" xm="12" sm="6" class="pa-1">
                        <v-text-field v-model="dDcbItinerario.Curricula" label="* Curricula" filled prepend-inner-icon="auto_stories" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 250) || 'El campo debe ser menor de 250 caracteres.']" :maxlength="250" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="12" sm="6" class="pa-1">
                        <v-text-field v-model="dDcbItinerario.DocumentoAutorizacion" label="* Doc. Autorización" filled prepend-inner-icon="insert_drive_file" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 250) || 'El campo debe ser menor de 250 caracteres.']" :maxlength="250" autocomplete="off"></v-text-field>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="12" xm="12" sm="4" class="pa-1">
                        <v-text-field v-model="dDcbItinerario.CreditosTeoricas" label="* Creditos Teórico" filled prepend-inner-icon="tag" :rules="[v => !!v || 'El campo es requerido']" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="12" sm="4" class="pa-1">
                        <v-text-field v-model="dDcbItinerario.CreditosPracticas" label="* Creditos Práctico" filled prepend-inner-icon="tag" :rules="[v => !!v || 'El campo es requerido']" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="12" sm="4" class="pa-1">
                        <v-text-field v-model="cTotalCreditos" label="Total Creditos" filled prepend-inner-icon="tag" type="number" disabled></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xm="12" sm="4" class="pa-1">
                        <v-text-field v-model="dDcbItinerario.HorasTeoricas" label="* Horas Teórico" filled prepend-inner-icon="update" :rules="[v => !!v || 'El campo es requerido']" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="12" sm="4" class="pa-1">
                        <v-text-field v-model="dDcbItinerario.HorasPracticas" label="* Horas Práctico" filled prepend-inner-icon="update" :rules="[v => !!v || 'El campo es requerido']" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="12" sm="4" class="pa-1">
                        <v-text-field v-model="cTotalHoras" label="Total Horas." filled prepend-inner-icon="update" type="number" disabled></v-text-field>
                    </v-col>
                    <span style="color:white">{{pIdServicio}}</span>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn @click.prevent="fuSave" :loading="dIsUpdating" :color="dColor"><v-icon left>save</v-icon> Guardar</v-btn>
                <v-spacer />
                <v-btn @click.prevent="pfuNew"><v-icon left>arrow_back</v-icon> CERRAR</v-btn>
            </v-card-actions>
            <v-snackbar v-model="dSnackbar.value" :color="dSnackbar.color">{{dSnackbar.msg}}
                <v-btn text @click="dSnackbar.value = false"> Cerrar </v-btn>
            </v-snackbar>
        </v-form>
    </v-card>
</template>

<script>
import gql from 'graphql-tag';
import {mapState} from 'vuex';

export default {
    name: 'DcbItinerarioAdd',
    props: {
        pfuNew: { type: Function },
        pLoad: { type: Function },
        pIdServicio: { type: Number},
        pIdItinerario: { type: Number}
    },
    mounted(){
        this.fuLoad();
        this.dDcbItinerario.IdServicio = this.pIdServicio;
    },
    data: () => ({
        dColor: 'success',
        dIsUpdating: false,
        dMatPeriodos: [],
        dDcbItinerario: {
            CreditosTeoricas:0,
            CreditosPracticas:0,
            HorasTeoricas:0,
            HorasPracticas: 0,
        },
        dSnackbar: {
            value: false,
            msg: '',
            color: '',
        }
    }),
    computed: {
        ...mapState(['ssPriServiciosIngreso']),
        cTotalCreditos () {
            return parseInt(this.dDcbItinerario.CreditosTeoricas) + parseInt(this.dDcbItinerario.CreditosPracticas);
        },
        cTotalHoras () {
            return parseInt(this.dDcbItinerario.HorasTeoricas) + parseInt(this.dDcbItinerario.HorasPracticas);
        }
    },
    watch: {
        'pIdServicio' (val) {
            if(val != '' && val)
                this.dDcbItinerario.IdServicio = val;
        },
        'pIdItinerario' (val) {
            if(val != '' && val)
                this.dColor = 'warning';
            else
                this.dColor = 'success';
            console.log('---',val);
        },
    },
    methods: {
        async fuLoad(){
            const response = await this.$apollo.query({
                query: gql`{
                    admconfigperiodoByIDCentroProd(IDCentroProd:1){
                        IdPeriodoAdmision
                        Anio_Periodo
                        FechaInicio
                    }
                }`
            })
            this.dMatPeriodos = response.data.admconfigperiodoByIDCentroProd.sort((p1, p2) => (p1.Anio_Periodo < p2.Anio_Periodo) ? 1 : (p1.Anio_Periodo > p2.Anio_Periodo) ? -1 : 0);;
        },
        fuSave () {
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = {value: true, msg: 'Revise el formulario, existe datos erróneos.', color: 'error'};
            } else {
                this.fuCreate();
            }
        },
        async fuCreate () {
            this.dIsUpdating = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation dcbitinerarioCreate($input: dcbitinerarioCreateInput!){
                        dcbitinerarioCreate(input: $input){
                            IdItinerario
                        }
                    }`,
                    variables: {
                        input: this.dDcbItinerario
                    }
                });
                if(response.data.dcbitinerarioCreate){
                    this.dSnackbar = {value: true, msg: 'Se guardó correctamente', color: 'success'};
                    this.dDcbItinerario = {
                        CreditosTeoricas:0,
                        CreditosPracticas:0,
                        HorasTeoricas:0,
                        HorasPracticas: 0,
                    };
                    this.pfuNew();
                    this.pLoad();
                } else {
                    console.log("No se guardo.");
                    this.dSnackbar = {value: true, msg: 'No se guardó', color: 'error'};
                }
            } catch (error) {
                console.log(error);
                this.dSnackbar = {value: true, msg: 'No se guardó', color: 'error'};
            } finally {
                this.dIsUpdating = false;
            }
        },
    }
}
</script>

<style>

</style>